/**
 * Get Pending Deliveries Use Case
 *
 * This use case handles the business logic for filtering pending deliveries.
 * It follows Single Responsibility Principle by handling only pending deliveries logic.
 *
 * @module GetPendingDeliveriesUseCase
 */

import {DistributionRecord, DistributionStatus} from '../models/distribution.model';

export class GetPendingDeliveriesUseCase {
  /**
   * Execute the use case to get pending deliveries
   * @param records - Array of distribution records
   * @returns Array of pending delivery records
   */
  execute (records: DistributionRecord[]): DistributionRecord[] {
    return records.filter(record =>
      record.status === DistributionStatus.PENDING
    );
  }
}

